module.exports = __webpack_public_path__ + "static/img/img_jiejue_fangan_tuyi.46b9b9ab.png";